<template>
  <div class="editPassword">
    <!--新增-->
    <el-dialog
      :title="$t('account.editPassword')"
      :visible.sync="dialogAdd"
      :close-on-click-modal="false"
      width="500px"
    >
      <el-form
        label-width="180px"
        ref="insertDialog"
        :inline="true"
        :label-position="'right'"
        :rules="updatePwdRule"
        :model="updatePwd"
      >
        <el-form-item :label="$t('account.accountName')" prop="accountName">
          <el-input
            v-model="updatePwd.userAccount"
            class="inputWidth"
            :placeholder="$t('account.phonePlaceholder')"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('account.newPassword')" prop="newPassword">
          <el-input
            type="password"
            v-model="updatePwd.newPassword"
            class="inputWidth"
            :placeholder="$t('account.newPasswordEmpty')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('account.againNewPassword')" prop="againNewPassword">
          <el-input
            type="password"
            v-model="updatePwd.againNewPassword"
            class="inputWidth"
            :placeholder="$t('account.againNewPasswordEmpty')"
          ></el-input>
        </el-form-item>
      </el-form>
      <div style="color: red; text-align: right">密码需包含英文和数字，长度最少8位</div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loading" @click="addSure()">{{
          $t('dialog.confirm')
        }}</el-button>
        <el-button @click="dialogAdd = false">{{ $t('dialog.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import API from '@/api/systemManage/account.js';
  export default {
    name: 'editPassword',
    data() {
      // 修改密码校验规则
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('account.againNewPasswordEmpty')));
        } else if (value != this.updatePwd.newPassword) {
          callback(new Error(this.$t('account.againNewPasswordEmptys')));
        } else {
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('account.newPasswordEmpty')));
        } else {
          /* else if (value.length < 8) {
        callback(new Error(this.$t("account.newPasswordEmptyOne")));
      }  */
          // 修改密码校验规则为:字母和数字不区分大小学
          let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{1,32}$/;
          if (reg.test(value)) {
            callback();
          } else {
            callback(new Error(this.$t('account.newPasswordEmptyTwo')));
          }
        }
      };
      return {
        dialogAdd: false,
        loading: false,
        userList: [],
        updatePwd: {
          accountName: '',
          userId: '',
          newPassword: '',
          againNewPassword: '',
        },
        updatePwdRule: {
          newPassword: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            { min: 1, max: 32, message: '长度在 8 到 32 个字符', trigger: 'blur' },
            { validator: validatePass2, trigger: 'blur' },
          ],
          againNewPassword: [
            { required: true, message: '请确认密码', trigger: 'blur' },
            { min: 1, max: 32, message: '长度在 8 到 32 个字符', trigger: 'blur' },
            { validator: validatePass, trigger: 'blur', required: true },
          ],
        },
      };
    },
    computed: {
      rules() {
        // 校验特殊字符
        // var specialValidate = (rule, value, callback) => {
        //   console.log(rule);
        //   var reg = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/;
        //   if (value.match(reg)) {
        //     callback(new Error(this.$t('menu.emoticons')));
        //   } else {
        //     callback();
        //   }
        // };

        return {};
      },
    },
    methods: {
      openDialog(flag, id) {
        if (this.$refs['insertDialog']) {
          this.$refs['insertDialog'].resetFields();
        }
        this.loading = false;
        this.dialogAdd = flag;
        //初始化页面数据
        this.getDetailInfo(id);
      },
      getDetailInfo(id) {
        this.$axios.get(API.GET_DETAIL_API + '/' + id).then((res) => {
          if (0 == res.data.code) {
            this.updatePwd = res.data.data;
            this.updatePwd.adminFlag = res.data.data.adminFlag.toString();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //保存
      addSure() {
        this.$refs.insertDialog.validate((valid) => {
          if (valid && !this.loading) {
            this.loading = true;
            const params = {
              newPassword: this.Base64.encode(this.updatePwd.newPassword),
              userAccount: this.updatePwd.accountName,
              userId: this.updatePwd.userId,
            };
            this.$axios.post(API.RESET_PASSWORD, params).then((res) => {
              this.loading = false;
              if (0 != res.data.code) {
                this.$alert(res.data.msg);
              } else {
                this.dialogAdd = false;
                this.$emit('getData');
                this.$message({
                  showClose: true,
                  message: res.data.msg || this.$t('message.success'),
                  type: 'success',
                });
              }
            });
          } else {
            return false;
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .inputWidth {
    width: 170px !important;
  }
</style>
